import React from "react";
import { Container, AppShell, Flex } from "@mantine/core";
import ImageCompressorComponent from "./components/image-compressor";
import FaviconGeneratorComponent from "./components/favicons-generator";

import styles from "./style.module.css";

const App: React.FC = () => {
    const date = new Date();
    const year = date.getFullYear();
    return (
        <AppShell
            header={{ height: 60 }}
            padding="md"
            className={styles["app-shell"]}
        >
            <AppShell.Header className={styles.header}>
                <Container size="xl">
                    <div className={styles.container}>
                        <img height="32" src="./logo.svg" alt="pixiel-logo"/>
                    </div> 
                </Container>
                {/* <Box className={styles['header-container']}> */}
                {/*     <img className={styles.logo} src="../public/pics_resizer_logo.svg" /> */}
                {/* </Box> */}
            </AppShell.Header>
            <Container size="lg">
                <Flex direction="column">
                    <ImageCompressorComponent />
                    <FaviconGeneratorComponent />
                </Flex>
            </Container >
            <AppShell.Footer className={styles.footer} h="4em" py="xs">
                <p>Copyright © {year}, Pics-Resizer All Rights Reserved.</p>
            </AppShell.Footer>
        </AppShell>
    );
};

export default App;
